// extracted by mini-css-extract-plugin
export default {"box":"DimensionsChart_box__oTfUh","header":"DimensionsChart_header__rGymC"};